// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__qc2SC","textBlock":"NotFound_textBlock__wFq3r","button":"NotFound_button__-n1Z-","imageBlock":"NotFound_imageBlock__d18Kz"};